import { alertActions } from ".";
import { CatalogueMasterConstants } from "../constants/CatalogueMasterConstants";
import { catalogueMasterService } from "../services/CatalogueMasterService";

export const CatalogueMasterActions = {
  getAll,
  upsertHeader,
  upsertDetails,
  loadingData,
};

function getAll(data) {
  return (dispatch) => {
    dispatch(request(data));

    catalogueMasterService.GetCatalogues(data).then(
      (response) => {
        if (response?.ResponseCode === "200") {
          dispatch(success(response.ResponseData));
        } else if (response?.ResponseCode === "400") {
          dispatch(alertActions.warning(response.ResponseMessage));
          dispatch(failure(response.ResponseMessage));
        } else {
          dispatch(alertActions.error(response.ResponseMessage));
          dispatch(failure(response.ResponseMessage));
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      },
    );
  };

  function request(data) {
    return { type: CatalogueMasterConstants.GETALL_REQUEST, data };
  }
  function success(data) {
    return { type: CatalogueMasterConstants.GETALL_SUCCESS, data };
  }
  function failure(error) {
    return { type: CatalogueMasterConstants.GETALL_FAILURE, error };
  }
}

function upsertHeader(data) {
  return (dispatch) => {
    dispatch(request(data));

    catalogueMasterService.UpsertCatalogueHeader(data).then(
      (response) => {
        if (response?.ResponseCode === "200") {
          dispatch(success(response.ResponseData));
          dispatch(alertActions.success(response.ResponseMessage));
        } else if (response?.ResponseCode === "400") {
          dispatch(alertActions.warning(response.ResponseMessage));
          dispatch(failure(response.ResponseMessage));
        } else {
          dispatch(alertActions.error(response.ResponseMessage));
          dispatch(failure(response.ResponseMessage));
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      },
    );
  };

  function request(data) {
    return { type: CatalogueMasterConstants.UPSERT_HEADER_REQUEST, data };
  }
  function success(data) {
    return { type: CatalogueMasterConstants.UPSERT_HEADER_SUCCESS, data };
  }
  function failure(error) {
    return { type: CatalogueMasterConstants.UPSERT_HEADER_FAILURE, error };
  }
}

function upsertDetails(data) {
  return (dispatch) => {
    dispatch(request(data));

    catalogueMasterService.UpsertCatalogueDetails(data).then(
      (response) => {
        if (response?.ResponseCode === "200") {
          dispatch(success(response.ResponseData));
          dispatch(alertActions.success(response.ResponseMessage));
        } else if (response?.ResponseCode === "400") {
          dispatch(alertActions.warning(response.ResponseMessage));
          dispatch(failure(response.ResponseMessage));
        } else {
          dispatch(alertActions.error(response.ResponseMessage));
          dispatch(failure(response.ResponseMessage));
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      },
    );
  };

  function request(data) {
    return { type: CatalogueMasterConstants.UPSERT_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: CatalogueMasterConstants.UPSERT_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: CatalogueMasterConstants.UPSERT_DETAILS_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: CatalogueMasterConstants.LOADING_REQUEST,
    isbool,
  };
}
